import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Electricmeter } from './electricmeter.model';
import { ElectricmeterPopupService } from './electricmeter-popup.service';
import { ElectricmeterService } from './electricmeter.service';
import { Marketplace, MarketplaceService } from '../marketplace';

@Component({
    selector: 'jhi-electricmeter-dialog',
    templateUrl: './electricmeter-dialog.component.html'
})
export class ElectricmeterDialogComponent implements OnInit {

    electricmeter: Electricmeter;
    authorities: any[];
    isSaving: boolean;

    marketplaces: Marketplace[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private electricmeterService: ElectricmeterService,
        private marketplaceService: MarketplaceService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['electricmeter']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketplaceService.query().subscribe(
            (res: Response) => { this.marketplaces = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.electricmeter.id !== undefined) {
            this.electricmeterService.update(this.electricmeter)
                .subscribe((res: Electricmeter) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.electricmeterService.create(this.electricmeter)
                .subscribe((res: Electricmeter) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Electricmeter) {
        this.eventManager.broadcast({ name: 'electricmeterListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackMarketplaceById(index: number, item: Marketplace) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-electricmeter-popup',
    template: ''
})
export class ElectricmeterPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private electricmeterPopupService: ElectricmeterPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.electricmeterPopupService
                    .open(ElectricmeterDialogComponent, params['id']);
            } else {
                this.modalRef = this.electricmeterPopupService
                    .open(ElectricmeterDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/electricmeter/electricmeter-dialog.component.ts